
export function karmaLoba (karmaX){
    const report = process.env.REACT_APP_KARMA; 
    const handyReporter = {
        [report]:karmaX
    } 
    return handyReporter
}
 
